import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SelectedDealerBannerUI from './SelectedDealerBannerUI';
import NotImplemented from '../NotImplemented';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, PE_SITE_NAME, HC_SITE_NAME, HF_SITE_NAME, } from '../../utils/constants';
import { bannerConfigs } from './utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
const SelectedDealerBanner = ({ dealerName, dealerHours, dealerLocatorUrl, testId }) => {
    const appName = useAppName();
    let configs = {
        icon: '',
        bgColor: '',
    };
    switch (appName) {
        case HONDA_SITE_NAME:
            configs = bannerConfigs[HONDA_SITE_NAME];
            break;
        case ACURA_SITE_NAME:
            configs = bannerConfigs[ACURA_SITE_NAME];
            break;
        case PE_SITE_NAME:
            configs = bannerConfigs[PE_SITE_NAME];
            break;
        case HC_SITE_NAME:
            configs = bannerConfigs[HC_SITE_NAME];
            break;
        case HF_SITE_NAME:
            configs = bannerConfigs[HF_SITE_NAME];
            break;
        default:
            return _jsx(NotImplemented, { name: "Selected Dealer Banner" });
    }
    const { icon, bgColor } = configs;
    return (_jsx(SelectedDealerBannerUI, { bannerBackgroundColor: bgColor, dealerName: dealerName, dealerHours: dealerHours, dealerIcon: icon, dealerLocatorUrl: dealerLocatorUrl, testId: testId }));
};
export default SelectedDealerBanner;
